const TicketIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.2501 10.6507C16.2501 9.50072 17.1834 8.56738 18.3334 8.56738V7.73405C18.3334 4.40072 17.5001 3.56738 14.1667 3.56738H5.83341C2.50008 3.56738 1.66675 4.40072 1.66675 7.73405V8.15072C2.81675 8.15072 3.75008 9.08405 3.75008 10.234C3.75008 11.384 2.81675 12.3174 1.66675 12.3174V12.734C1.66675 16.0674 2.50008 16.9007 5.83341 16.9007H14.1667C17.5001 16.9007 18.3334 16.0674 18.3334 12.734C17.1834 12.734 16.2501 11.8007 16.2501 10.6507Z"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 12.5264L12.5 7.52637"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4953 12.526H12.5028"
      stroke="#91A2BB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49534 7.94303H7.50283"
      stroke="#91A2BB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TicketIcon;
